import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { TimePicker as AntTimePicker } from 'antd';
import styled from 'styled-components';
var TimePicker = styled(AntTimePicker).attrs(function () {
  return {
    placeholder: ''
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    &.ant-picker {\n      width: 100%;\n  \n      &.ant-picker-focused {\n        box-shadow: none;\n      }\n    }\n  "])));
export default TimePicker;